import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadDecisionSummary = (documentId, siteId) =>
  get(`${url}/leasingDocument/${documentId}/${siteId}/alpha/decisionSummary`);

const exp = {
  loadDecisionSummary
};

export default exp;
